(function(){
  const THRESHOLD=7500; // £75, GBP only — see updateCartTotals below

  /* The currency every amount in the drawer is actually denominated in
     right now — kept in sync with cart.currency on every fresh /cart.js
     fetch (renderCart/updateCartTotals), since that's the one source
     guaranteed to be accurate regardless of whether this storefront's
     Markets/currency-picker setup also exposes window.Shopify.currency.
     Defaults to GBP before the first cart fetch, matching this file's
     previous hardcoded behaviour for anyone who never switches. */
  var activeCurrency='GBP';
  /* A small symbol map rather than Intl.NumberFormat with the browser's
     own locale: Intl's symbol placement/spacing can vary by visitor
     locale even for the SAME currency (e.g. a fr-FR browser formats GBP
     as "39,00 £", not "£39.00"), which would make GBP shoppers see
     something different from "exactly what they see today" depending on
     their browser — not acceptable. This map is deterministic for every
     visitor; anything not in it falls back to "CODE amount" (e.g.
     "JPY 1000") rather than guessing a wrong symbol. */
  var CURRENCY_SYMBOLS={GBP:'£',USD:'$',EUR:'€',CAD:'$',AUD:'$',NZD:'$'};
  function formatMoney(c){
    var symbol=CURRENCY_SYMBOLS[activeCurrency];
    var amount=(c/100).toFixed(2);
    return symbol ? (symbol+amount) : (activeCurrency+' '+amount);
  }

  /* Pop Protector cases must never appear as upsell candidates — they're
     Unlisted, but Unlisted just means "hidden from nav/search", not
     invisible to these AJAX endpoints, so they're excluded by handle
     everywhere a candidate list is built. */
  var CASE_HANDLES=['pop-protector-clear','pop-protector-blood-splatter','pop-protector-ectoplasm'];

  /* The 7 "I ❤️ [Character]" hunter-parcel products and The Whole Trunk
     they can upgrade to — matched by handle (same approach as
     CASE_HANDLES above), since /products/{handle}.js is already the data
     every cart line carries (item.handle), no extra lookup needed to spot
     one. */
  var HUNTER_PARCEL_HANDLES=['i-love-sam-mystery-parcel-goblin-wood-exclusive','i-love-dean-mystery-parcel-goblin-wood-exclusive','i-love-castiel-mystery-parcel-goblin-wood-exclusive','i-love-crowley-mystery-parcel-goblin-wood-exclusive','i-love-bobby-mystery-parcel-goblin-wood-exclusive','i-love-charlie-mystery-parcel-goblin-wood-exclusive','i-love-the-winchesters-mystery-parcel-goblin-wood-exclusive'];
  var TRUNK_HANDLE='the-whole-trunk-hunters-mega-parcel-goblin-wood-exclusive';

  /* bundle-3-for-10's real price is £12, not £10 — the tag name is stale
     (kept as-is so it keeps targeting the real Shopify Buy X Get Y
     discount) but was never renamed. Shared by the existing per-line
     badge AND the new "complete the deal" upsell heading, so this stale-
     price exception only ever needs fixing in one place. */
  function bundlePriceLabel(tag){
    var raw=tag.split('bundle-3-for-')[1];
    return tag==='bundle-3-for-10'?'12':raw;
  }

  /* Mirrors snippets/gw-badge-slot.liquid's tag logic. */
  function bundleTagOf(tags){
    if(!tags||!tags.length)return null;
    for(var i=0;i<tags.length;i++){if(tags[i].indexOf('bundle-3-for-')===0)return tags[i];}
    return null;
  }
  function franchiseTagOf(tags){
    if(!tags||!tags.length)return null;
    for(var i=0;i<tags.length;i++){if(tags[i].indexOf('franchise:')===0)return tags[i];}
    return null;
  }
  function bundleBadgeHtml(tags){
    var tag=bundleTagOf(tags);
    if(!tag)return'';
    return '<span class="gw-drawer__bundle-badge">3 for £'+bundlePriceLabel(tag)+'</span>';
  }
  /* Mirrors the metafield check in snippets/gw-badge-slot.liquid,
     via the same "web-exclusive" tag used by search-drawer.liquid, for
     the same reason: product.metafields aren't in the /products/{handle}.js
     response this file already fetches for the bundle badge (checked —
     that response has tags but no metafields field), so no extra request
     is needed, just check for this tag on the same data. */
  function webExclusiveBadgeHtml(tags){
    if(!tags||tags.indexOf('web-exclusive')===-1)return'';
    return '<span class="gw-drawer__webex-badge">Web Exclusive</span>';
  }

  /* Handmade / Made to order / Hand-picked lead-time line — reads the
     same #gw-handmade-config JSON snippets/gw-handmade-lightbox.liquid
     renders sitewide (one config object shared with the card badges and
     the product-page price line, so editing copy in the customiser
     never needs touching this file). Priority among the three tags
     themselves (made-to-order > handmade > hand-picked) matches
     gw-badge-slot.liquid and gw-handmade-price-line.liquid exactly —
     a product can only ever show one. */
  var handmadeConfigCache=null;
  function getHandmadeConfig(){
    if(handmadeConfigCache) return handmadeConfigCache;
    var el=document.getElementById('gw-handmade-config');
    try{ handmadeConfigCache=JSON.parse(el.textContent); }catch(e){ handmadeConfigCache={}; }
    return handmadeConfigCache;
  }
  function handmadeTypeOf(tags){
    if(!tags)return null;
    var cfg=getHandmadeConfig();
    if(tags.indexOf('gw-made-to-order')!==-1 && cfg.mto && cfg.mto.enabled)return'mto';
    if(tags.indexOf('gw-handmade')!==-1 && cfg.handmade && cfg.handmade.enabled)return'handmade';
    if(tags.indexOf('gw-hand-picked')!==-1 && cfg.hand_picked && cfg.hand_picked.enabled)return'hand_picked';
    return null;
  }
  var HANDMADE_ICONS={
    handmade:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 12.5V5.5a1.5 1.5 0 0 1 3 0v5.5"/><path d="M11.5 11V4.5a1.5 1.5 0 0 1 3 0V11"/><path d="M14.5 11.5V6.5a1.5 1.5 0 0 1 3 0v7.5c0 3.5-2.5 6.5-6.5 6.5-2.8 0-4.3-1.1-5.5-3.3l-2-3.8a1.3 1.3 0 0 1 2.3-1.3l1.7 2.5"/></svg>',
    mto:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 4 8.3 15.7a2 2 0 1 0 2.8 2.8L20 10"/><circle cx="20" cy="4" r="1.2"/><path d="M4 19c1-1.3 2.3-1.3 3.3-.3s2.3 1 3.3-.3"/></svg>',
    hand_picked:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="9.5" r="6.5"/><path d="M9 9.5 11 11.5 15.5 7"/><path d="M8.5 15.5 7 21l5-2 5 2-1.5-5.5"/></svg>'
  };
  function handmadeLineHtml(tags){
    var type=handmadeTypeOf(tags);
    if(!type)return'';
    var cfg=getHandmadeConfig();
    var data=cfg[type];
    if(!data)return'';
    // Made to order ships variably per product (see the product
    // description), so it deliberately has no lead-time setting — the
    // separator is only added when there's actually a second thing to
    // separate, never a stray trailing "·".
    var leadPart=data.leadTime?(' &middot; '+escapeHtml(data.leadTime)):'';
    return '<button type="button" class="gw-drawer__handmade-line gw-drawer__handmade-line--'+type+'" data-gw-handmade-trigger="'+type+'" aria-haspopup="dialog">'
      +'<span class="gw-drawer__handmade-icon" aria-hidden="true">'+(HANDMADE_ICONS[type]||'')+'</span>'
      +escapeHtml(data.label)+leadPart
      +'</button>';
  }

  function escapeHtml(s){
    return String(s==null?'':s).replace(/[&<>"']/g,function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  /* /products/{handle}.js gives tags (no "collections" field — confirmed
     by testing, that field simply isn't in this endpoint's response), so
     it's the one source used everywhere tags are needed: per-line
     badges AND the upsell logic's deal/franchise detection. Cached per
     handle for the session — tags don't change while someone's shopping,
     and the same handle often gets looked up twice in one render (once
     for its own line, once as a candidate elsewhere). */
  var productDataCache={};
  function fetchProductData(handle){
    if(productDataCache[handle]) return productDataCache[handle];
    var p=fetch('/products/'+handle+'.js').then(function(r){return r.json();}).catch(function(){return null;});
    productDataCache[handle]=p;
    return p;
  }

  /* The last full /cart.js response rendered, kept so click handlers (the
     +/- steppers, remove) can look up a line's sibling Pop/case without a
     network round trip before deciding what to do. Always replaced with
     a fresh server response after every change — never mutated locally. */
  var currentCart = null;

  /* Bumped every time updateTrunkMiniCard starts a NEW async check — lets
     a stale check (e.g. from a render that's since been superseded by a
     newer one, such as a quick second add landing before the first one's
     Trunk-availability fetch resolves) recognise it's out of date and
     skip inserting, instead of appending a stale/duplicate card onto a
     wrap that's already been rebuilt by the newer render. */
  var trunkCardGen = 0;

  /* A single transient note shown above the cart lines — either the
     post-swap "Upgraded ✓ · Undo" note (for ~6s) or a short one-off
     message (e.g. an undo failure). Re-rendered after every renderCart
     pass (see renderDrawerNote calls below) so it survives the line
     list being rebuilt while it's still active. */
  var drawerNote = null;

  /* ---- Case <-> Pop linking (Round 3) ------------------------------------
     A case line carries a hidden `_for_variant` property (set by
     assets/pop-case-picker.js) pointing at its Pop's variant id, alongside
     the visible "For" property already shown under the line. Rules:
       - lowering a Pop's quantity below its case's quantity caps the case
         to match
       - removing a Pop (quantity 0) removes its linked case line(s) too
       - a case's own + can't take it above its Pop's current quantity
       - raising a Pop's quantity never auto-adds or auto-raises a case
     applyCaseLinkRules is idempotent and safe to call after ANY cart
     change from anywhere (the drawer's own controls, "Fans also love",
     or Dawn's stock /cart page via the pubsub hook wired at the bottom of
     this file) — it only ever fixes real violations, never invents one. */
  function findPopForCase(cart, caseItem){
    var forVariant = caseItem.properties && caseItem.properties._for_variant;
    if(!forVariant) return null;
    return cart.items.find(function(i){ return String(i.variant_id)===String(forVariant); }) || null;
  }

  function applyCaseLinkRules(cart){
    var changes=[];
    cart.items.forEach(function(item){
      var pop=findPopForCase(cart,item);
      var forVariant=item.properties&&item.properties._for_variant;
      if(!forVariant) return; // not a case line
      if(!pop){
        changes.push({id:item.key,quantity:0});
      } else if(item.quantity>pop.quantity){
        changes.push({id:item.key,quantity:pop.quantity});
      }
    });
    if(!changes.length) return Promise.resolve(cart);
    return changes.reduce(function(p,change){
      return p.then(function(){
        return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(change)});
      });
    },Promise.resolve()).then(function(){
      return fetch('/cart.js').then(function(r){return r.json();});
    });
  }

  const SHIPPING_ICON='<span class="gw-drawer__shipping-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00b4b4" stroke-width="2" aria-hidden="true"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg></span>';
  function updateCartTotals(cart){
    // activeCurrency is already set for this pass — see renderCart,
    // which sets it before building any line (and before this runs).
    const shippingEl=document.getElementById('gw-drawer-shipping');
    if(activeCurrency==='GBP'){
      // The £75 threshold only means anything measured against a GBP
      // total — this is the exact behaviour GBP shoppers had before.
      const rem=Math.max(0,THRESHOLD-cart.total_price);
      const pct=Math.min(100,(cart.total_price/THRESHOLD)*100);
      shippingEl.innerHTML=`<div class="gw-drawer__shipping-text">${SHIPPING_ICON}${rem>0?`Spend <strong style="color:#fff;margin:0 3px">${formatMoney(rem)}</strong> more for free UK shipping`:'<strong style="color:#00b4b4">You\'ve unlocked free UK shipping!</strong>'}</div><div class="gw-drawer__shipping-bar"><div class="gw-drawer__shipping-fill" style="width:${pct}%"></div></div>`;
    } else {
      // Hidden entirely for non-GBP visitors, not just text-replaced —
      // this bar/threshold is a GBP-specific promise with no reliable
      // live FX rate available here to convert it correctly, so rather
      // than show any version of it to a non-UK visitor, it's simply
      // not shown at all. GBP visitors are completely unaffected.
      shippingEl.innerHTML='';
    }
    document.getElementById('gw-drawer-subtotal').textContent=formatMoney(cart.total_price);
    updateHeaderCount(cart);
  }

  function updateHeaderCount(cart){
    /* querySelectorAll, not querySelector — the slim sticky header
       (gw-slim-header.liquid) renders its own cart badge too, and both
       need to stay in sync. Scoped to data-gw-cart-count/-bubble
       specifically (not the shared .cart-count-bubble class) because
       the wishlist badge also carries .cart-count-bubble for styling
       reuse — matching on that class alone would wrongly overwrite the
       wishlist's own count with the cart's. */
    document.querySelectorAll('[data-gw-cart-count]').forEach(function(el){
      el.textContent=cart.item_count;
    });
    document.querySelectorAll('[data-gw-cart-bubble]').forEach(function(bubble){
      bubble.style.display = cart.item_count>0 ? '' : 'none';
    });
  }

  /* One full cart line: image, title, variant, "For: X" (case lines
     only), badges, line total, qty stepper, remove. `productData` is
     this line's own /products/{handle}.js response (tags), already
     fetched by renderCart before any line is built — badges render
     synchronously from it instead of each line firing its own fetch. */
  function renderLine(item, isNew, productData){
    const el=document.createElement('div');
    el.className='gw-drawer__product-item'+(isNew?' gw-drawer__product-item--new':'');
    el.dataset.key=item.key;
    el.dataset.variantId=item.variant_id;
    const forVariant=item.properties&&item.properties._for_variant;
    if(forVariant) el.dataset.forVariant=forVariant;
    const vt=item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:'';
    // "For" (Pop Protector cases) and "With" (gw-addon-picker, e.g. the
    // beanie+gloves offer) are both just visible labels on top of the
    // same generic _for_variant link — whichever one a line actually
    // carries is shown using its own word, so new add-on offers can pick
    // whatever word reads best without a cart-drawer.js change.
    var forPropKey=['For','With'].find(function(k){ return item.properties && item.properties[k]; });
    const forLabel=forPropKey?item.properties[forPropKey]:null;
    const tags=productData?productData.tags:null;
    // Shopify's /cart.js already gives every line its POST-discount
    // price (line_price) alongside the pre-discount one
    // (original_line_price) and which discount(s) actually applied
    // (item.discounts, each with its own .title) — no calculation
    // needed here, just deciding whether to show the struck-through
    // version at all.
    const hasDiscount=item.original_line_price!==item.line_price;
    const priceHtml=hasDiscount
      ? `<p class="gw-drawer__product-price"><s class="gw-drawer__product-price--was">${formatMoney(item.original_line_price)}</s> ${formatMoney(item.line_price)}</p>`
      : `<p class="gw-drawer__product-price">${formatMoney(item.line_price)}</p>`;
    const discountNames=hasDiscount&&item.discounts&&item.discounts.length
      ? `<p class="gw-drawer__product-discount">${escapeHtml(item.discounts.map(function(d){return d.title;}).join(', '))}</p>`
      : '';
    el.innerHTML=`
      <img src="${item.image||''}" alt="${escapeHtml(item.product_title)}">
      <div class="gw-drawer__product-info">
        <p class="gw-drawer__product-title">${escapeHtml(item.product_title)}</p>
        ${vt?`<p class="gw-drawer__product-variant">${escapeHtml(vt)}</p>`:''}
        ${forLabel?`<p class="gw-drawer__product-for">${escapeHtml(forPropKey)}: ${escapeHtml(forLabel)}</p>`:''}
        ${discountNames}
        <span class="gw-drawer__badge-slot">${webExclusiveBadgeHtml(tags)}${bundleBadgeHtml(tags)}</span>
        ${handmadeLineHtml(tags)}
        <div class="gw-drawer__line-row">
          <div class="gw-drawer__stepper" role="group" aria-label="Quantity">
            <button type="button" class="gw-drawer__step-btn" data-step="-1" aria-label="Decrease quantity">−</button>
            <span class="gw-drawer__qty" aria-live="polite">${item.quantity}</span>
            <button type="button" class="gw-drawer__step-btn" data-step="1" aria-label="Increase quantity">+</button>
          </div>
          ${priceHtml}
        </div>
        <p class="gw-drawer__line-message" data-line-message hidden></p>
      </div>
      <button type="button" class="gw-drawer__remove" aria-label="Remove ${escapeHtml(item.product_title)}">&times;</button>
    `;
    if(isNew){
      setTimeout(function(){ el.classList.remove('gw-drawer__product-item--new'); },2200);
    }
    return el;
  }

  /* Renders the WHOLE cart every time — not just what was just added —
     so the subtotal shown always matches the lines shown (round 3's
     main fix: previously only the just-added item(s) were listed while
     the subtotal covered the entire basket). `justAddedVariantIds` is an
     array of variant ids to briefly highlight; pass [] to render with no
     highlight (used when opening from the header cart icon). Fetches
     every line's product data ONCE up front (cached), uses it for that
     line's badges, then hands the same data straight to the upsell
     logic below — no separate/duplicate fetch pass for that. */
  function renderCart(cart, justAddedVariantIds){
    // Must happen before ANY formatMoney call this pass makes — line
    // items are built further down in this same function, before
    // updateCartTotals (where this used to live) ever runs, so setting
    // it there was one render-pass too late: the very first line item
    // in a session would format in whatever currency was active BEFORE
    // this cart was fetched (the hardcoded GBP default, on a first
    // load), not the one this cart is actually in.
    if(cart.currency) activeCurrency=cart.currency;
    currentCart=cart;
    updateHeaderCount(cart);
    document.dispatchEvent(new CustomEvent('gw:cart:change',{detail:{cart:cart}}));
    const wrap=document.getElementById('gw-drawer-product');
    const upsellEl=document.getElementById('gw-drawer-upsell');
    if(!cart.items.length){
      wrap.innerHTML='';
      wrap.appendChild(renderEmptyState());
      if(upsellEl) upsellEl.innerHTML='';
      updateCartTotals(cart);
      renderDrawerNote();
      return;
    }
    justAddedVariantIds=justAddedVariantIds||[];
    const lookups=cart.items.map(function(item){
      return fetchProductData(item.handle).then(function(data){ return {item:item,data:data}; });
    });
    Promise.all(lookups).then(function(results){
      wrap.innerHTML='';
      results.forEach(function(r){
        const isNew=justAddedVariantIds.indexOf(r.item.variant_id)!==-1;
        wrap.appendChild(renderLine(r.item,isNew,r.data));
      });
      updateCartTotals(cart);
      // Upsell loads after the basket list is visible, not before —
      // keeps the drawer feeling instant even if the upsell logic's own
      // extra lookups (candidate search etc.) take a beat longer.
      updateUpsell(cart,results,justAddedVariantIds);
      updateTrunkMiniCard(cart,results);
      renderDrawerNote();
    });
  }

  function renderEmptyState(){
    const el=document.createElement('div');
    el.className='gw-drawer__empty';
    el.innerHTML=`<p class="gw-drawer__empty-text">Your bag is empty</p><button type="button" class="gw-drawer__empty-continue">Continue shopping</button>`;
    el.querySelector('.gw-drawer__empty-continue').addEventListener('click',closeDrawer);
    return el;
  }

  function showAddedBanner(){
    const banner=document.querySelector('.gw-drawer__added');
    if(!banner)return;
    banner.classList.add('is-visible');
    clearTimeout(showAddedBanner._t);
    showAddedBanner._t=setTimeout(function(){ banner.classList.remove('is-visible'); },2600);
  }

  function hideAddedBanner(){
    const banner=document.querySelector('.gw-drawer__added');
    if(banner) banner.classList.remove('is-visible');
  }

  /* Round 4: the page behind must stay scrollable while the drawer is
     open (no body scroll-lock) — removed the overflow:hidden toggle
     entirely. The drawer panel itself gets overscroll-behavior:contain
     (CSS) so scrolling inside it never "leaks" into the page once it
     hits the top/bottom of the list. */
  function openDrawerWithCart(cart, opts){
    opts=opts||{};
    const drawer=document.getElementById('gw-cart-drawer');
    renderCart(cart, opts.justAddedVariantIds||[]);
    if(opts.showAdded){ showAddedBanner(); } else { hideAddedBanner(); }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
  }

  function closeDrawer(){
    const drawer=document.getElementById('gw-cart-drawer');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
  }

  /* ---- Smart upsell (replaces the old collection-based "Fans also
     love") ----------------------------------------------------------
     Priority order, matching the brief exactly:
       A) complete a deal — an incomplete bundle-3-for-N group in the
          basket (quantity in that tag group isn't a multiple of 3)
       B) matching items — same design as the most recently added line
          (design name = the part of its title before the first " - "
          or " – ", the same convention product titles already use;
          confirmed live via predictive search that a plain text query
          on that fragment returns genuinely related products)
       C) same franchise fallback — Shopify's own /recommendations
          endpoint, filtered to the anchor's franchise: tag
     `results` is the [{item,data}] array renderCart just fetched for
     the line badges — reused here instead of a second fetch pass. */

  function isExcludedHandle(handle){
    return CASE_HANDLES.indexOf(handle)!==-1;
  }

  function findIncompleteBundleGroup(results){
    var groups={}; // tag -> {qty, franchiseTag}
    results.forEach(function(r){
      var tags=r.data&&r.data.tags;
      var bundleTag=bundleTagOf(tags);
      if(!bundleTag) return;
      if(!groups[bundleTag]) groups[bundleTag]={qty:0,franchiseTag:null};
      groups[bundleTag].qty+=r.item.quantity;
      var fr=franchiseTagOf(tags);
      if(fr) groups[bundleTag].franchiseTag=fr;
    });
    var incompleteTag=null;
    Object.keys(groups).forEach(function(tag){
      if(incompleteTag) return;
      if(groups[tag].qty%3!==0) incompleteTag=tag;
    });
    return incompleteTag?{tag:incompleteTag,info:groups[incompleteTag]}:null;
  }

  /* Read once — sections/gw-addon-offer-data.liquid, a static section
     rendered sitewide in layout/theme.liquid so this works on ANY page,
     not just the offer product's own (the beanie can be added from the
     homepage spotlight, a quick-add card, or search, none of which ever
     load main-product.liquid's own picker). One offer today; if a
     second is ever needed at the same time this would need to become a
     list, but nothing else here assumes there's only ever one. */
  var addonOfferConfigCache;
  function getAddonOfferConfig(){
    if(addonOfferConfigCache!==undefined) return addonOfferConfigCache;
    var el=document.getElementById('gw-addon-offer-config');
    try{
      var cfg=el?JSON.parse(el.textContent):null;
      addonOfferConfigCache=(cfg&&cfg.enabled&&cfg.trigger_tag)?cfg:null;
    }catch(e){ addonOfferConfigCache=null; }
    return addonOfferConfigCache;
  }

  /* Finds an add-on-offer "trigger" product (e.g. the beanie) in the
     basket with fewer LINKED add-ons (gloves whose _for_variant points
     back to it) than its own quantity — same _for_variant link the
     Pop/case cascade already uses, so a glove added any other way (not
     through this deal row) still counts correctly. Returns the first
     under-served trigger line found; null if none or if every trigger
     already has enough linked add-ons. */
  function findAddonOfferDeal(results){
    var config=getAddonOfferConfig();
    if(!config) return null;
    var triggers=results.filter(function(r){ return r.data&&(r.data.tags||[]).indexOf(config.trigger_tag)!==-1; });
    if(!triggers.length) return null;
    for(var i=0;i<triggers.length;i++){
      var t=triggers[i];
      var linkedQty=results.reduce(function(sum,r){
        var forVariant=r.item.properties&&r.item.properties._for_variant;
        return sum+(String(forVariant)===String(t.item.variant_id)?r.item.quantity:0);
      },0);
      if(linkedQty<t.item.quantity){
        return{config:config,missing:t.item.quantity-linkedQty,triggerVariantId:t.item.variant_id,triggerTitle:t.item.product_title};
      }
    }
    return null;
  }

  function predictiveSearchProducts(query,limit){
    return fetch('/search/suggest.json?q='+encodeURIComponent(query)+'&resources[type]=product&resources[limit]='+(limit||10)+'&resources[options][unavailable_products]=hide')
      .then(function(r){return r.json();})
      .then(function(d){return (d.resources&&d.resources.results&&d.resources.results.products)||[];})
      .catch(function(){return [];});
  }

  /* Predictive search results don't carry a stable numeric `product_id`
     matching cart lines' product_id in every store config, so "already
     in cart" / dedupe here checks by handle instead (always present and
     always matches). */
  function inCartHandles(results){
    return results.map(function(r){return r.item.handle;});
  }

  /* Predictive search results don't carry a usable price (a decimal
     string, not integer minor units) or a real variant id at all — same
     issue documented in assets/gw-product-matching.js. Every shortlisted
     deal candidate gets re-fetched through that module's own
     gw-product-data endpoint so the rendered card has a correct price
     and an actual add-to-cart variant id, same as the character/
     franchise tiers. */
  function hydrateDealCandidates(handles){
    if(typeof window.gwProductMatchingHelpers === 'undefined') return Promise.resolve([]);
    return Promise.all(handles.map(window.gwProductMatchingHelpers.fetchProductData)).then(function(dataList){
      return dataList.filter(function(d){return d && d.available!==false;});
    });
  }

  function dealCandidates(bundleTag, franchiseTag, results){
    var query='tag:'+bundleTag+(franchiseTag?' tag:'+franchiseTag:'');
    return predictiveSearchProducts(query,12).then(function(products){
      var excludeHandles=inCartHandles(results);
      var filtered=products.filter(function(p){
        return !isExcludedHandle(p.handle) && p.available!==false && excludeHandles.indexOf(p.handle)===-1;
      });
      if(franchiseTag && filtered.length<3){
        // Franchise-filtered search came up short — retry without it
        // rather than showing too few (or zero) candidates.
        return predictiveSearchProducts('tag:'+bundleTag,12).then(function(products2){
          var filtered2=products2.filter(function(p){
            return !isExcludedHandle(p.handle) && p.available!==false && excludeHandles.indexOf(p.handle)===-1;
          });
          return hydrateDealCandidates(filtered2.slice(0,4).map(function(p){return p.handle;}));
        });
      }
      return hydrateDealCandidates(filtered.slice(0,4).map(function(p){return p.handle;}));
    });
  }

  /* Character/franchise matching itself now lives in the shared
     assets/gw-product-matching.js (used by this drawer AND the product
     page's "You may also like" section — one decision, not two copies).
     This just supplies the cart-specific exclusion list and unwraps the
     {tier, products} result into the two outcomes updateUpsell cares
     about. */
  // Blends the two anchors' own (already per-anchor capped) results into
  // one list, deduping by handle and re-capping per type across the
  // COMBINED set — otherwise two anchors that each independently return,
  // say, 2 pin badges would show 4 pin badges and nothing else.
  function mergeAndCapByType(lists, maxPerType, limit){
    var counts={}, seen={}, out=[];
    lists.forEach(function(list){
      list.forEach(function(p){
        if(out.length>=limit) return;
        if(seen[p.handle]) return;
        var t=p.product_type||'unknown';
        counts[t]=counts[t]||0;
        if(counts[t]>=maxPerType) return;
        counts[t]++; seen[p.handle]=true; out.push(p);
      });
    });
    return out;
  }

  function matchOrFranchiseCandidates(anchorItem, results){
    if(typeof window.gwFindMatchingProducts !== 'function') return Promise.resolve({tier:'none',products:[]});
    return window.gwFindMatchingProducts(anchorItem.handle,{
      excludeHandles:inCartHandles(results),
      caseHandles:CASE_HANDLES,
      limit:4,
      maxPerType:2,
    });
  }

  function renderUpsellRow(heading, products){
    const el=document.getElementById('gw-drawer-upsell');
    if(!el) return;
    if(!products.length){ el.innerHTML=''; return; }
    let html=`<p class="gw-drawer__upsell-title">${escapeHtml(heading)}</p>`+
      `<div class="gw-drawer__upsell-wrap">`+
      `<div class="gw-drawer__upsell-row" data-upsell-track>`;
    const stickerConfig=getAddonOfferConfig();
    products.forEach(function(u){
      const multiVariant=u.variants_count>1;
      const hasSticker=stickerConfig&&stickerConfig.sticker_tag&&(u.tags||[]).indexOf(stickerConfig.sticker_tag)!==-1;
      html+=`<div class="gw-drawer__upsell-card">`+
        (hasSticker?`<img class="gw-offer-sticker gw-offer-sticker--small" src="${stickerConfig.sticker_url}" alt="" aria-hidden="true">`:'')+
        `<img src="${u.featured_image||''}" alt="${escapeHtml(u.title)}">`+
        `<p class="gw-drawer__upsell-name">${escapeHtml((u.title||'').split(' - ')[0])}</p>`+
        `<p class="gw-drawer__upsell-price">${formatMoney(u.price)}</p>`+
        (multiVariant
          ? `<a class="gw-drawer__upsell-btn gw-drawer__upsell-btn--link" href="${u.url}">Select</a>`
          : `<button type="button" class="gw-drawer__upsell-btn" data-variant-id="${u.first_variant_id}">+ Add</button>`)+
        `</div>`;
    });
    html+='</div>'+
      // Same round ‹ › arrow pattern as new-arrivals-carousel.js, sized
      // and coloured for the drawer's dark background.
      `<button type="button" class="gw-drawer__upsell-arrow gw-drawer__upsell-arrow--prev" aria-label="Previous">&#8249;</button>`+
      `<button type="button" class="gw-drawer__upsell-arrow gw-drawer__upsell-arrow--next" aria-label="Next">&#8250;</button>`+
      '</div>';
    el.innerHTML=html;
    el.querySelectorAll('.gw-drawer__upsell-btn:not(.gw-drawer__upsell-btn--link)').forEach(function(btn){
      btn.addEventListener('click',function(){
        if (window.location.pathname.includes('hexbox-case-file')) return;
        const id=this.dataset.variantId;
        this.disabled=true;
        this.textContent='Adding...';
        const b=this;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
          .then(function(r){return r.json();})
          .then(function(item){
            noteParcelAdd(item);
            fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
              openDrawerWithCart(cart,{showAdded:true,justAddedVariantIds:[item.variant_id]});
            });
          })
          .catch(function(){ b.disabled=false; b.textContent='+ Add'; });
      });
    });
    wireUpsellArrows(el);
  }

  function wireUpsellArrows(el){
    const track=el.querySelector('[data-upsell-track]');
    const prev=el.querySelector('.gw-drawer__upsell-arrow--prev');
    const next=el.querySelector('.gw-drawer__upsell-arrow--next');
    if(!track) return;
    function cardStep(){
      const card=track.querySelector('.gw-drawer__upsell-card');
      return card?card.offsetWidth+12:120;
    }
    function updateArrows(){
      const atStart=track.scrollLeft<=0;
      const atEnd=track.scrollLeft+track.clientWidth>=track.scrollWidth-1;
      if(prev){ prev.classList.toggle('is-disabled',atStart); }
      if(next){ next.classList.toggle('is-disabled',atEnd); }
    }
    if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-cardStep(),behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ track.scrollBy({left:cardStep(),behavior:'smooth'}); });
    track.addEventListener('scroll',updateArrows,{passive:true});
    updateArrows();
  }

  /* The add-on-offer deal row (e.g. beanie + gloves) — generic for any
     offer described by sections/gw-addon-offer-data.liquid. Each card
     fetches its own full product data (variants/options/availability)
     on demand so sizes can be offered inline, same size-required rule
     as the picker on the product page: if a product has more than one
     variant with a "Size" option, clicking "+ Add" reveals size pills
     first instead of adding immediately. */
  /* Bolds the first £amount (the actual deal price) and lightens a
     trailing "(was £X)" so the heading reads at a glance — generic
     string formatting, not tied to this specific offer's wording, so
     any future add-on offer's own heading text gets the same styling
     for free. */
  function formatDealHeading(text){
    return escapeHtml(text)
      .replace(/(£\d+(?:\.\d{2})?)/, '<strong class="gw-drawer__deal-heading-price">$1</strong>')
      .replace(/(\(was[^)]*\))/i, '<span class="gw-drawer__deal-heading-was">$1</span>');
  }

  function renderAddonDealRow(deal){
    const el=document.getElementById('gw-drawer-upsell');
    if(!el) return;
    const config=deal.config;
    Promise.all(config.products.map(function(h){ return fetchProductData(h); })).then(function(products){
      const valid=products.filter(function(p){ return p&&p.variants&&p.variants.some(function(v){return v.available;}); });
      if(!valid.length){ el.innerHTML=''; return; }
      let html=`<p class="gw-drawer__deal-heading">${formatDealHeading(config.heading)}</p>`+
        `<div class="gw-drawer__deal-row">`;
      valid.forEach(function(p,i){
        html+=`<div class="gw-drawer__deal-card" data-index="${i}">`+
          `<img src="${p.featured_image?p.featured_image.replace(/\.(png|jpe?g|webp)/,'_160x.$1'):''}" alt="${escapeHtml(p.title)}">`+
          `<p class="gw-drawer__deal-name">${escapeHtml(p.title.split(' - ')[0])}</p>`+
          `<div class="gw-drawer__deal-sizes" hidden></div>`+
          `<button type="button" class="gw-drawer__deal-btn">+ Add</button>`+
          `</div>`;
      });
      html+='</div>';
      el.innerHTML=html;

      el.querySelectorAll('.gw-drawer__deal-card').forEach(function(card){
        const p=valid[parseInt(card.dataset.index,10)];
        // product.options from /products/{handle}.js is an array of
        // OBJECTS ({name, position, values}), not plain strings — testing
        // the object itself against /size/i always coerced to the
        // literal string "[object Object]" and never matched, which is
        // why "+ Add" was adding the first variant straight away instead
        // of asking for a size. Test o.name instead.
        const sizeOptionIndex=(p.options||[]).findIndex(function(o){ return /size/i.test(o.name); });
        const discountMinor=(config.discount_amount||0)*100;
        const btn=card.querySelector('.gw-drawer__deal-btn');
        const sizesEl=card.querySelector('.gw-drawer__deal-sizes');

        function addVariant(variant){
          const properties={};
          properties[config.property_label]=deal.triggerTitle;
          properties._for_variant=deal.triggerVariantId;
          btn.disabled=true; btn.textContent='Adding...';
          window.gwInterceptAddToCartMulti([{id:variant.id,quantity:deal.missing,properties:properties}])
            .catch(function(){ btn.disabled=false; btn.textContent='+ Add'; });
        }

        function priceLabel(variant){
          const now=Math.max(0,variant.price-discountMinor);
          return `${formatMoney(now)} <s>${formatMoney(variant.price)}</s>`;
        }

        // Distinct variants by size only (collapses any other option
        // dimension, e.g. a colour variant, to whichever comes first for
        // that size) — same simplification as the product-page picker.
        const sizeVariants=[];
        if(sizeOptionIndex>-1){
          const seen={};
          (p.variants||[]).forEach(function(v){
            const size=v.options[sizeOptionIndex];
            if(size&&!seen[size]){ seen[size]=true; sizeVariants.push({size:size,variant:v}); }
          });
        }

        if(sizeOptionIndex===-1||sizeVariants.length<=1){
          const variant=(p.variants||[]).find(function(v){return v.available;});
          card.querySelector('.gw-drawer__deal-name').insertAdjacentHTML('afterend',`<p class="gw-drawer__deal-price">${priceLabel(variant)}</p>`);
          btn.addEventListener('click',function(){ if(variant) addVariant(variant); });
          return;
        }

        card.querySelector('.gw-drawer__deal-name').insertAdjacentHTML('afterend',`<p class="gw-drawer__deal-price">${formatMoney(Math.max(0,sizeVariants[0].variant.price-discountMinor))} <s>${formatMoney(sizeVariants[0].variant.price)}</s></p>`);
        btn.addEventListener('click',function(){
          if(!sizesEl.hidden) return;
          sizesEl.hidden=false;
          sizesEl.innerHTML=sizeVariants.map(function(sv){
            return `<button type="button" class="gw-size-pill"${sv.variant.available?'':' disabled'}>${escapeHtml(sv.size)}</button>`;
          }).join('');
          Array.from(sizesEl.children).forEach(function(pillEl,idx){
            if(pillEl.disabled) return;
            pillEl.addEventListener('click',function(){ addVariant(sizeVariants[idx].variant); });
          });
        });
      });
    });
  }

  function updateUpsell(cart, results, justAddedVariantIds){
    const el=document.getElementById('gw-drawer-upsell');
    if(!el) return;
    if(!cart.items.length){ el.innerHTML=''; return; }

    const addonDeal=findAddonOfferDeal(results);
    if(addonDeal){ renderAddonDealRow(addonDeal); return; }

    const deal=findIncompleteBundleGroup(results);
    if(deal){
      const missing=3-(deal.info.qty%3);
      const heading='Add '+missing+' more to get 3 for £'+bundlePriceLabel(deal.tag);
      dealCandidates(deal.tag,deal.info.franchiseTag,results).then(function(products){
        renderUpsellRow(heading,products);
      });
      return;
    }

    // Anchors are picked from the WHOLE basket, not just the last line —
    // and never from a case or a bundle item (pop-case-picker cases carry
    // zero tags of any kind, so using one as the anchor was falling
    // straight through to the generic recommendations fallback with no
    // real signal to work from — confirmed live, that's what was
    // surfacing coasters). Ranked by quantity (the customer's clearest
    // signal of what they actually care about), ties broken by whichever
    // was added most recently / is furthest along in the cart.
    var anchorCandidates=results.filter(function(r){
      return !isExcludedHandle(r.item.handle) && !bundleTagOf(r.data&&r.data.tags);
    });
    if(!anchorCandidates.length){ el.innerHTML=''; return; }
    var justAddedSet=(justAddedVariantIds||[]);
    anchorCandidates.sort(function(a,b){
      if(b.item.quantity!==a.item.quantity) return b.item.quantity-a.item.quantity;
      var aJust=justAddedSet.indexOf(a.item.variant_id)!==-1?1:0;
      var bJust=justAddedSet.indexOf(b.item.variant_id)!==-1?1:0;
      if(bJust!==aJust) return bJust-aJust;
      return results.indexOf(b)-results.indexOf(a);
    });
    var topAnchors=anchorCandidates.slice(0,2);

    Promise.all(topAnchors.map(function(r){ return matchOrFranchiseCandidates(r.item,results); })).then(function(anchorResults){
      var primary=anchorResults[0];
      var heading=(primary.tier==='design'||primary.tier==='character')?'Complete the set':'Fans also love';
      var products=mergeAndCapByType(anchorResults.map(function(r){return r.products;}),2,4);
      renderUpsellRow(heading,products);
    });
  }

  /* ---- Trunk upgrade card: detection, label helpers, note/undo ---------- */

  /* "I ❤️ Cas" from a title like "I ❤️ Cas - Mystery Parcel - Goblin Wood
     Exclusive" — same `.split(' - ')[0]` convention already used for
     upsell/deal card names elsewhere in this file. */
  function parcelShortName(item){
    return (item.product_title||'').split(' - ')[0];
  }
  /* variant_title is "<tier> / <size>" for these products — tier is
     either the Deluxe one (contains "Deluxe", in both the old "£40 -
     Deluxe Parcel" and new "Deluxe Parcel" option names — a substring
     check, so this needs no change either way) or the standard one (old
     "£20 - Parcel", new plain "Parcel"). The standard-tier short label
     used to be built by string-mangling the OLD option name itself
     ("£20 - Parcel" -> "£20 Parcel") — worked only because that name
     happened to already contain the price as text. Built from the
     line item's own real price via formatMoney instead now, so it's
     correct in the visitor's actual presentment currency and doesn't
     care what the option value says at all, old name or new. */
  function parcelOptionLabel(item){
    var parts=(item.variant_title||'').split(' / ');
    var tier=parts[0]||'';
    var size=parts[1]||'';
    if(tier.indexOf('Deluxe')!==-1){
      return (size && size!=='One size') ? ('Deluxe, '+size) : 'Deluxe';
    }
    return formatMoney(item.price)+' Parcel';
  }
  function parcelSwapLabel(item){
    return parcelShortName(item)+' – '+parcelOptionLabel(item);
  }
  /* The parcel's own size, but ONLY for a Deluxe line (the £20 tier has
     no real size to match a Trunk size against) — used to pre-select a
     Trunk size button when a Deluxe parcel is the one being swapped. */
  function parcelDeluxeSize(item){
    var parts=(item.variant_title||'').split(' / ');
    var tier=parts[0]||'';
    var size=parts[1]||'';
    if(tier.indexOf('Deluxe')!==-1 && size && size!=='One size') return size;
    return null;
  }
  /* "I ❤️ Dean", or "I ❤️ Dean (Deluxe, Small)" if more than one line in
     the basket shares that same short name (two different tiers/sizes
     of the same character) — used for the link-mode heading, "Fancy
     upgrading your [this]?". */
  function parcelHeadingName(item, parcelResults){
    var name=parcelShortName(item);
    var sameNameCount=parcelResults.filter(function(r){ return parcelShortName(r.item)===name; }).length;
    if(sameNameCount>1) return name+' ('+parcelOptionLabel(item)+')';
    return name;
  }

  /* Shopify's /cart.js item order isn't guaranteed to match the order
     things were actually added in (confirmed live: adding Cas then
     Crowley can still come back with Crowley first) — so "default to
     the LAST parcel line" can't just mean "last in cart.items". This
     tracks hunter-parcel line keys in the order they were actually
     added/topped-up (most-recent last), independent of whatever order
     the server hands back. Re-adding an existing line moves it to the
     end rather than duplicating it. */
  var parcelAddOrder=[];
  function noteParcelAdd(item){
    if(!item||!item.handle||HUNTER_PARCEL_HANDLES.indexOf(item.handle)===-1) return;
    var idx=parcelAddOrder.indexOf(item.key);
    if(idx!==-1) parcelAddOrder.splice(idx,1);
    parcelAddOrder.push(item.key);
  }
  /* Picks whichever line in `parcelResults` was added most recently per
     parcelAddOrder, falling back to the last entry in `parcelResults`
     itself (cart.items order) if none of them are in the tracker yet —
     e.g. parcels already in the basket from before this file loaded. */
  function mostRecentParcel(parcelResults){
    for(var i=parcelAddOrder.length-1;i>=0;i--){
      var match=parcelResults.find(function(r){ return r.item.key===parcelAddOrder[i]; });
      if(match) return match.item;
    }
    return parcelResults[parcelResults.length-1].item;
  }

  /* Single transient note above the cart lines: either the post-swap
     undo offer (6s) or a one-off message (e.g. an undo failure).
     Re-inserted by renderDrawerNote after every renderCart pass so it
     survives #gw-drawer-product being rebuilt while still active. */
  function renderDrawerNote(){
    var wrap=document.getElementById('gw-drawer-product');
    if(!wrap) return;
    var existing=wrap.querySelector('[data-drawer-note]');
    if(existing) existing.remove();
    if(!drawerNote) return;
    var note=document.createElement('div');
    note.setAttribute('data-drawer-note','');
    note.setAttribute('role','status');
    note.setAttribute('aria-live','polite');
    if(drawerNote.type==='undo'){
      note.className='gw-drawer__undo-note';
      note.innerHTML='Upgraded to The Whole Trunk &#10003; &middot; <button type="button" class="gw-drawer__undo-btn" data-undo-btn>Undo</button>';
      wrap.insertBefore(note, wrap.firstChild);
      note.querySelector('[data-undo-btn]').addEventListener('click',function(){
        clearTimeout(drawerNote.timeoutId);
        var data=drawerNote.undoData;
        drawerNote=null;
        renderDrawerNote();
        performUndo(data);
      });
    } else {
      note.className='gw-drawer__undo-note gw-drawer__undo-note--message';
      note.textContent=drawerNote.text;
      wrap.insertBefore(note, wrap.firstChild);
    }
  }
  function showUndoNote(undoData){
    var timeoutId=setTimeout(function(){ drawerNote=null; renderDrawerNote(); },6000);
    drawerNote={type:'undo',undoData:undoData,timeoutId:timeoutId};
    renderDrawerNote();
  }
  function showDrawerMessage(text){
    var timeoutId=setTimeout(function(){ drawerNote=null; renderDrawerNote(); },4000);
    drawerNote={type:'message',text:text,timeoutId:timeoutId};
    renderDrawerNote();
  }

  /* Undo: add back exactly 1 of the same parcel variant (with its
     original properties, if any — Shopify merges this straight back
     into the still-present line if quantity was only reduced, or
     recreates it if it was removed entirely), then remove the ONE
     Trunk unit the swap added. Leaves things as they were (re-rendered
     from the real cart) if either step fails, with a short message. */
  function performUndo(undoData){
    var addBody={id:undoData.variantId,quantity:undoData.quantity};
    if(undoData.properties) addBody.properties=undoData.properties;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(addBody)})
      .then(function(r){ return r.json().then(function(data){ return {ok:r.ok,data:data}; }); })
      .then(function(res){
        if(!res.ok||!res.data||!res.data.id){
          showDrawerMessage("Couldn't undo — nothing else changed.");
          return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){ renderCart(cart,[]); });
        }
        return fetch('/cart.js').then(function(r){return r.json();}).then(function(cartNow){
          // Targets THIS swap's own Trunk line specifically (by the key
          // captured when it was added), never just "a" Trunk line —
          // with multiple parcels each swapped separately, the basket
          // can have several Trunk lines at once and undo must only
          // touch the one this swap created.
          var trunkLine=undoData.trunkLineKey
            ? cartNow.items.find(function(i){ return i.key===undoData.trunkLineKey; })
            : cartNow.items.find(function(i){ return i.handle===TRUNK_HANDLE; });
          if(!trunkLine){
            showDrawerMessage("The parcel's back, but couldn't find that Trunk line to remove — remove it yourself.");
            renderCart(cartNow,[]);
            return;
          }
          return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:trunkLine.key,quantity:Math.max(0,trunkLine.quantity-1)})})
            .then(function(r2){ return r2.json(); })
            .then(function(cart2){ renderCart(cart2,[]); })
            .catch(function(){
              showDrawerMessage("The parcel's back, but The Whole Trunk couldn't be removed — remove it yourself.");
              return fetch('/cart.js').then(function(r3){return r3.json();}).then(function(c3){ renderCart(c3,[]); });
            });
        });
      })
      .catch(function(){
        showDrawerMessage("Couldn't undo — nothing else changed.");
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){ renderCart(cart,[]); });
      });
  }

  /* The upgrade card itself. Collapsed by default (same look as before:
     dark card, amber border, UPGRADE tab, thumbnail, name, description,
     price) but the whole thing is now a <button> that expands in place
     — swapping one unit of the chosen parcel for one unit of a chosen
     Trunk size, rather than linking away. `parcelResults` is every
     hunter-parcel line currently in the basket (not just one), so the
     swap dropdown only appears when there's a real choice to make. */
  function buildTrunkCard(trunk, parcelResults, hasTrunk){
    var wrap=document.createElement('div');
    wrap.className='gw-drawer__trunk-card-wrap';
    var thumbHtml=trunk.featured_image
      ? '<span class="gw-drawer__trunk-card-thumb"><img src="'+trunk.featured_image.replace(/\.(png|jpe?g|webp)/,'_160x.$1')+'" alt=""></span>'
      : '';
    var tabText=hasTrunk?'UPGRADE ANOTHER':'UPGRADE';
    wrap.innerHTML=
      '<span class="gw-drawer__trunk-card-connector" data-trunk-connector aria-hidden="true"><svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M3 1 V8 Q3 12 7 12 H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>'+
      '<div class="gw-drawer__trunk-card" data-trunk-card>'+
        '<span class="gw-drawer__trunk-card-tab" aria-hidden="true">'+tabText+'</span>'+
        '<p class="gw-drawer__trunk-card-heading" data-trunk-heading hidden></p>'+
        '<button type="button" class="gw-drawer__trunk-card-toggle" data-trunk-toggle aria-expanded="false" aria-label="Upgrade to The Whole Trunk, '+formatMoney(trunk.price)+'">'+
          thumbHtml+
          '<span class="gw-drawer__trunk-card-body">'+
            '<span class="gw-drawer__trunk-card-name">The Whole Trunk</span>'+
            '<span class="gw-drawer__trunk-card-sub">Our biggest hunter mystery parcel, loaded to the boot.</span>'+
          '</span>'+
          '<span class="gw-drawer__trunk-card-price">'+formatMoney(trunk.price)+' <span aria-hidden="true">&rarr;</span></span>'+
        '</button>'+
        '<div class="gw-drawer__trunk-swap" data-trunk-swap hidden>'+
          '<div class="gw-drawer__trunk-swap-group" data-trunk-parcel-group hidden>'+
            '<label class="gw-drawer__trunk-swap-label" for="gw-trunk-parcel-select">Swap which one?</label>'+
            '<select class="gw-drawer__trunk-swap-select" id="gw-trunk-parcel-select" data-trunk-parcel-select></select>'+
          '</div>'+
          '<div class="gw-drawer__trunk-swap-group">'+
            '<span class="gw-drawer__trunk-swap-label" id="gw-trunk-size-label">Choose your size</span>'+
            '<div class="gw-drawer__trunk-swap-sizes" role="group" aria-labelledby="gw-trunk-size-label" data-trunk-size-group></div>'+
          '</div>'+
          '<button type="button" class="gw-drawer__trunk-swap-btn" data-trunk-swap-btn disabled>Swap for The Whole Trunk</button>'+
          '<p class="gw-drawer__trunk-swap-msg" data-trunk-swap-msg aria-live="polite" hidden></p>'+
          '<div class="gw-drawer__trunk-swap-links">'+
            '<a href="'+trunk.url+'" class="gw-drawer__trunk-swap-what">What’s inside? &rarr;</a>'+
            '<button type="button" class="gw-drawer__trunk-swap-cancel" data-trunk-cancel>Cancel</button>'+
          '</div>'+
        '</div>'+
      '</div>';

    var cardEl=wrap.querySelector('[data-trunk-card]');
    var connectorEl=wrap.querySelector('[data-trunk-connector]');
    var headingEl=wrap.querySelector('[data-trunk-heading]');
    var toggleBtn=wrap.querySelector('[data-trunk-toggle]');
    var swapPanel=wrap.querySelector('[data-trunk-swap]');
    var parcelGroup=wrap.querySelector('[data-trunk-parcel-group]');
    var parcelSelect=wrap.querySelector('[data-trunk-parcel-select]');
    var sizeGroup=wrap.querySelector('[data-trunk-size-group]');
    var swapBtn=wrap.querySelector('[data-trunk-swap-btn]');
    var msgEl=wrap.querySelector('[data-trunk-swap-msg]');
    var cancelBtn=wrap.querySelector('[data-trunk-cancel]');
    var trunkVariants=(trunk.variants||[]).slice();
    var selectedVariantId=null;
    var swapping=false;

    function reduceMotion(){
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    function setExpanded(expand){
      toggleBtn.setAttribute('aria-expanded', expand?'true':'false');
      if(reduceMotion()){ swapPanel.hidden=!expand; return; }
      if(expand){
        swapPanel.hidden=false;
        requestAnimationFrame(function(){ swapPanel.classList.add('is-open'); });
      } else {
        swapPanel.classList.remove('is-open');
        setTimeout(function(){ swapPanel.hidden=true; },260);
      }
    }
    function showMsg(text){ msgEl.textContent=text||''; msgEl.hidden=!text; }
    function currentParcelItem(){
      if(parcelResults.length>1 && parcelSelect.value){
        var match=parcelResults.find(function(r){ return r.item.key===parcelSelect.value; });
        if(match) return match.item;
      }
      return mostRecentParcel(parcelResults);
    }
    /* Builds the size buttons ONCE per parcel/size context (called from
       preselectForParcel — on expand, and on a dropdown change — never
       from inside a size button's own click handler). Selecting a size
       only toggles classes/attributes on the buttons already in the
       DOM (markSelectedSize) — it must NEVER rebuild this innerHTML in
       response to a click on one of these buttons.

       ROOT CAUSE of "tap any size button and the whole drawer closes":
       this function used to be called again, rebuilding the group's
       innerHTML, from inside the very click handler it attaches below —
       replacing (and thereby detaching from the document) the button
       that was just clicked WHILE that click event was still bubbling
       up toward document. The drawer's outside-click-closes listener
       checks panel.contains(e.target) on every document click; once
       e.target had been detached mid-bubble, that check came back
       false, so it looked exactly like a tap outside the drawer and
       closed it — no size was ever recorded as selected because the
       swap logic never got that far. */
    function renderSizeButtons(){
      sizeGroup.innerHTML=trunkVariants.map(function(v){
        return '<button type="button" class="gw-drawer__trunk-size-btn" data-size-variant="'+v.id+'" aria-pressed="false"'+(v.available?'':' disabled')+'>'+escapeHtml(v.title)+'</button>';
      }).join('');
      sizeGroup.querySelectorAll('[data-size-variant]').forEach(function(btn){
        btn.addEventListener('click',function(){
          if(btn.disabled) return;
          selectedVariantId=btn.dataset.sizeVariant;
          markSelectedSize();
          updateSwapButton();
        });
      });
      markSelectedSize();
    }
    function markSelectedSize(){
      sizeGroup.querySelectorAll('[data-size-variant]').forEach(function(btn){
        var sel=String(btn.dataset.sizeVariant)===String(selectedVariantId);
        btn.classList.toggle('is-selected',sel);
        btn.setAttribute('aria-pressed',sel?'true':'false');
      });
    }
    function updateSwapButton(){
      if(!selectedVariantId){ swapBtn.disabled=true; swapBtn.textContent='Swap for The Whole Trunk'; return; }
      var variant=trunkVariants.find(function(v){ return String(v.id)===String(selectedVariantId); });
      var parcelItem=currentParcelItem();
      if(!variant){ swapBtn.disabled=true; return; }
      var diff=Math.max(0, variant.price - parcelItem.price);
      swapBtn.disabled=false;
      swapBtn.textContent='Swap for The Whole Trunk · +'+formatMoney(diff);
    }
    function preselectForParcel(){
      var parcelItem=currentParcelItem();
      var size=parcelDeluxeSize(parcelItem);
      selectedVariantId=null;
      if(size){
        var match=trunkVariants.find(function(v){ return v.available && v.title.trim().toLowerCase()===size.trim().toLowerCase(); });
        if(match) selectedVariantId=String(match.id);
      }
      renderSizeButtons();
      updateSwapButton();
    }

    /* Connector vs link mode. The target is whichever parcel is
       currently chosen (dropdown, or the default last-added one). It's
       CONNECTOR mode only when that parcel's own line is the one
       directly above this card in the basket — i.e. this card's own
       wrapper (wrap, now appended as #gw-drawer-product's last child)
       sits immediately after that line's element. Any other case is
       LINK mode: no connector, teal border on both the card and the
       target line, a heading naming the target, and a synced 3-lap
       chase the first time a given target is highlighted (on open, or
       whenever the dropdown selection changes) before settling to a
       plain still teal border/outline — matching "fall back to still
       teal borders" wherever the animation can't run (prefers-reduced-
       motion, or a browser that just doesn't animate the custom
       property smoothly; the solid colour is applied unconditionally,
       the animated ring is purely an extra on top of it). */
    var highlightedLineEl=null;
    function clearHighlight(){
      if(highlightedLineEl){
        highlightedLineEl.classList.remove('gw-drawer__product-item--link-target','is-chasing');
        highlightedLineEl=null;
      }
      cardEl.classList.remove('gw-drawer__trunk-card--link','is-chasing');
      connectorEl.hidden=false;
      headingEl.hidden=true;
      headingEl.textContent='';
    }
    function applyHighlight(){
      clearHighlight();
      var targetItem=currentParcelItem();
      var lineEl=productWrap().querySelector('[data-key="'+targetItem.key+'"]');
      var isConnector = lineEl && wrap.previousElementSibling===lineEl;
      if(isConnector || !lineEl){
        return; // default look: connector shown, no teal, nothing else to do
      }
      connectorEl.hidden=true;
      headingEl.hidden=false;
      headingEl.textContent='Fancy upgrading your '+parcelHeadingName(targetItem,parcelResults)+'?';
      cardEl.classList.add('gw-drawer__trunk-card--link');
      lineEl.classList.add('gw-drawer__product-item--link-target');
      highlightedLineEl=lineEl;
      if(!reduceMotion()){
        cardEl.classList.add('is-chasing');
        lineEl.classList.add('is-chasing');
        setTimeout(function(){
          cardEl.classList.remove('is-chasing');
          if(highlightedLineEl===lineEl) lineEl.classList.remove('is-chasing');
        },7500); // 3 laps at 2.5s each
      }
    }
    function productWrap(){ return document.getElementById('gw-drawer-product'); }

    if(parcelResults.length>1){
      parcelGroup.hidden=false;
      parcelSelect.innerHTML=parcelResults.map(function(r){
        return '<option value="'+escapeHtml(r.item.key)+'">'+escapeHtml(parcelSwapLabel(r.item))+'</option>';
      }).join('');
      parcelSelect.value=mostRecentParcel(parcelResults).key;
      parcelSelect.addEventListener('change',function(){ showMsg(''); preselectForParcel(); applyHighlight(); });
    }

    toggleBtn.addEventListener('click',function(){
      var expand=swapPanel.hidden;
      if(expand){ showMsg(''); preselectForParcel(); }
      setExpanded(expand);
    });
    cancelBtn.addEventListener('click',function(){ setExpanded(false); });

    swapBtn.addEventListener('click',function(){
      if(swapping||swapBtn.disabled) return;
      swapping=true;
      swapBtn.disabled=true;
      var originalLabel=swapBtn.textContent;
      swapBtn.textContent='Swapping…';
      showMsg('');
      var parcelItem=currentParcelItem();
      var props={ _upgraded_from: parcelSwapLabel(parcelItem) };
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:selectedVariantId,quantity:1,properties:props})})
        .then(function(r){ return r.json().then(function(data){ return {ok:r.ok,data:data}; }); })
        .then(function(res){
          if(!res.ok||!res.data||!res.data.id){
            var msg=(res.data&&(res.data.description||res.data.message))||"Couldn't add The Whole Trunk — nothing changed. Try again.";
            swapping=false; swapBtn.disabled=false; swapBtn.textContent=originalLabel;
            showMsg(msg);
            return;
          }
          var nextQty=parcelItem.quantity-1;
          var newTrunkLineKey=res.data.key;
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parcelItem.key,quantity:nextQty})})
            .then(function(r2){ return r2.json(); })
            .then(function(cart2){
              // trunkLineKey ties undo to THIS swap's own Trunk line
              // specifically — with multiple Trunks now possible in the
              // basket (one per upgraded parcel), undo must never touch
              // a different swap's line.
              showUndoNote({variantId:parcelItem.variant_id,quantity:1,properties:parcelItem.properties||null,trunkLineKey:newTrunkLineKey});
              renderCart(cart2,[]);
            })
            .catch(function(){
              showDrawerMessage('The Whole Trunk was added — you can remove the parcel yourself.');
              fetch('/cart.js').then(function(r3){return r3.json();}).then(function(cart3){ renderCart(cart3,[]); });
            });
        })
        .catch(function(){
          swapping=false; swapBtn.disabled=false; swapBtn.textContent=originalLabel;
          showMsg("Couldn't add The Whole Trunk — nothing changed. Try again.");
        });
    });

    preselectForParcel();
    // applyHighlight needs `wrap` to already be attached to the document
    // (it checks wrap.previousElementSibling to decide connector vs link
    // mode) — it isn't yet at this point, so the caller runs it after
    // appending wrap, not this function itself.
    return {element:wrap, applyHighlight:applyHighlight};
  }

  /* Shown once, directly under the LAST line item in the basket — simply
     appended as the final child of #gw-drawer-product once every real
     line is already there, so it can never land in the wrong place and
     needs no fragile per-line DOM lookup. Also can't push out the
     shipping bar or cross-sell row, both of which are outside this
     scrollable container. Hidden if the basket already has the Trunk,
     or if the Trunk isn't available.

     ROOT CAUSE of the "doesn't always show" bug this replaces: the old
     version used results.find() to grab a single "first parcel" line,
     then looked it up again in the DOM via
     wrap.querySelector('[data-key=...]') to insert after it. That
     lookup — and the whole call — silently did nothing if: (a) the
     matched line's key no longer matched anything in the DOM (e.g. a
     second, fast-overlapping renderCart pass had already rebuilt the
     wrap with fresh elements by the time this async check resolved), or
     (b) a stale check from a superseded render ran its insertion after
     a newer one had already finished. Neither failure path showed any
     error — the card just never appeared. Fixed two ways: detection now
     uses results.some()/filter() (no dependency on which specific line
     is "first", so order/quantity/combination never matters), and
     insertion is a plain wrap.appendChild() once the real lines are
     already in place (no DOM lookup to fail), guarded by a render-
     generation counter so a stale async check from a superseded render
     can never insert a stale or duplicate card. */
  function updateTrunkMiniCard(cart, results){
    var wrap=document.getElementById('gw-drawer-product');
    if(!wrap) return;
    var myGen=++trunkCardGen;
    // Shows as long as ANY parcel is left, even with one or more Trunks
    // already in the basket — a Sam+Dean basket keeps offering the
    // upgrade for Dean after Sam's already been swapped. The tab text
    // (UPGRADE vs UPGRADE ANOTHER) is the only thing that reflects
    // hasTrunk now.
    var hasTrunk=cart.items.some(function(i){ return i.handle===TRUNK_HANDLE; });
    var parcelResults=results.filter(function(r){ return HUNTER_PARCEL_HANDLES.indexOf(r.item.handle)!==-1; });
    if(!parcelResults.length) return;
    fetchProductData(TRUNK_HANDLE).then(function(trunk){
      if(myGen!==trunkCardGen) return;
      if(!trunk||trunk.available===false) return;
      if(!wrap.lastElementChild) return;
      var card=buildTrunkCard(trunk,parcelResults,hasTrunk);
      wrap.appendChild(card.element);
      card.applyHighlight();
    });
  }

  function interceptAddToCart(variantId, quantity, collection, sellingPlan) {
    const body = { id: variantId, quantity: quantity || 1 };
    if (sellingPlan) body.selling_plan = sellingPlan;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(r => r.json())
      .then(item => {
        noteParcelAdd(item);
        fetch('/cart.js').then(r => r.json()).then(cart => {
          openDrawerWithCart(cart,{showAdded:true,justAddedVariantIds:[item.variant_id]});
        });
      });
  }

  /* Pop Protector case picker (assets/pop-case-picker.js) adds the Pop and
     the chosen case in ONE /cart/add.js request using its `items` array
     form, rather than the single-item form interceptAddToCart uses above.
     Shopify's items-array endpoint REJECTS the whole request if any line
     can't be fulfilled in most cases, but real testing against this store
     also surfaced a partial-fulfillment response (a quantity silently
     capped down rather than the request being rejected outright) — so
     this doesn't trust atomicity blindly. If the number of lines Shopify
     actually added doesn't match what was asked for, that's treated as a
     failure too: everything just added is removed again via /cart/change.js
     before rejecting, so the Pop is never left in the cart on its own
     just because the case's stock ran out mid-request. Returns a promise
     so the caller can show its own friendly message on rejection; a
     genuine network/parse failure (not a Shopify error payload) rejects
     with a plain, generic object rather than leaking a raw parse error to
     the customer. */
  function interceptAddToCartMulti(items) {
    var genericError = { description: "That case just sold out — nothing was added. Try again or pick a different case." };

    function rollBack(addedItems) {
      var changes = addedItems.map(function (item) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      });
      return Promise.all(changes).catch(function () {});
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () { return Promise.reject(genericError); })
          .then(function (data) {
            if (!r.ok || data.status) return Promise.reject(data);
            return data;
          });
      })
      .then(function (data) {
        var addedItems = data.items || [];
        if (addedItems.length !== items.length) {
          return rollBack(addedItems).then(function () { return Promise.reject(genericError); });
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var variantIds = addedItems.map(function(item){ return item.variant_id; });
          openDrawerWithCart(cart,{showAdded:true,justAddedVariantIds:variantIds});
        });
      });
  }

  /* ---- Line controls: stepper + remove, event-delegated on the list -----
     One listener on the container rather than one per button, since the
     whole list is rebuilt on every render. `data-loading` on the row
     guards against a double-tap firing a second request before the first
     one's response (and re-render) lands. */
  function setRowLoading(row,loading){
    if(loading) row.setAttribute('data-loading','1');
    else row.removeAttribute('data-loading');
  }

  function showLineMessage(row,text){
    const msg=row.querySelector('[data-line-message]');
    if(!msg)return;
    msg.textContent=text;
    msg.hidden=false;
    clearTimeout(msg._t);
    msg._t=setTimeout(function(){ msg.hidden=true; },3200);
  }

  function changeLine(key,quantity){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:quantity})})
      .then(function(r){return r.json();});
  }

  function afterLineChange(cartOrPromise,row,requestedQty){
    return Promise.resolve(cartOrPromise).then(function(cart){
      return applyCaseLinkRules(cart).then(function(finalCart){
        // If the server capped the quantity below what we asked for (out
        // of stock), the line we changed will show a lower quantity than
        // requested — say so, briefly, before the row is rebuilt away.
        if(row&&typeof requestedQty==='number'){
          var key=row.dataset.key;
          var line=finalCart.items.find(function(i){return i.key===key;});
          var actualQty=line?line.quantity:0;
          if(actualQty<requestedQty && actualQty>0){
            showLineMessage(row,'Only '+actualQty+' left');
          }
        }
        renderCart(finalCart,[]);
      });
    });
  }

  function wireLineControls(){
    const wrap=document.getElementById('gw-drawer-product');
    wrap.addEventListener('click',function(e){
      const stepBtn=e.target.closest('[data-step]');
      const removeBtn=e.target.closest('.gw-drawer__remove');
      const row=e.target.closest('.gw-drawer__product-item');
      if(!row)return;
      if(row.getAttribute('data-loading')==='1')return;

      if(removeBtn){
        setRowLoading(row,true);
        changeLine(row.dataset.key,0).then(function(cart){ return afterLineChange(cart,row,0); });
        return;
      }

      if(stepBtn){
        const delta=parseInt(stepBtn.dataset.step,10);
        const qtyEl=row.querySelector('.gw-drawer__qty');
        const current=parseInt(qtyEl.textContent,10)||0;
        let next=current+delta;

        if(delta>0 && row.dataset.forVariant && currentCart){
          // A case line's + can't take it above its linked Pop's
          // quantity — capped client-side first (cheap, instant), the
          // server-side applyCaseLinkRules call below is the real
          // source of truth and would also fix this if it somehow got
          // past this check.
          const pop=currentCart.items.find(function(i){return String(i.variant_id)===String(row.dataset.forVariant);});
          const cap=pop?pop.quantity:0;
          if(next>cap){
            showLineMessage(row,'Max '+cap+' — matches your Pop\'s quantity');
            return;
          }
        }

        if(next<1){
          setRowLoading(row,true);
          changeLine(row.dataset.key,0).then(function(cart){ return afterLineChange(cart,row,0); });
          return;
        }

        setRowLoading(row,true);
        changeLine(row.dataset.key,next).then(function(cart){ return afterLineChange(cart,row,next); });
      }
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    const drawer=document.getElementById('gw-cart-drawer');
    if(!drawer)return;
    drawer.querySelector('.gw-drawer__close').addEventListener('click',closeDrawer);
    drawer.querySelector('.gw-drawer__continue').addEventListener('click',closeDrawer);
    wireLineControls();

    /* Round 4: click/tap anywhere outside the panel closes the drawer
       (previously deliberately didn't, to let a customer keep browsing
       behind it — reversed on request). The overlay stays
       pointer-events:none (gw-cart-drawer.css) and clicks are caught
       here via document-level delegation instead, so this ALSO closes
       on a click straight through to a real page element behind the
       overlay, not just a click on the dimmed overlay itself.
       Distinguishes a genuine tap from a scroll/swipe ending under the
       pointer (a real risk on touch) by comparing the pointerdown and
       click positions — anything that moved more than a few px was a
       drag/swipe, not a tap, and is ignored. */
    var outsideStart=null;
    document.addEventListener('pointerdown',function(e){
      outsideStart={x:e.clientX,y:e.clientY};
    });
    document.addEventListener('click',function(e){
      if(!drawer.classList.contains('is-open')) return;
      const panel=drawer.querySelector('.gw-drawer__panel');
      if(panel.contains(e.target)) return;
      if(e.target.closest('#cart-icon-bubble')) return;
      if(outsideStart){
        const dx=Math.abs((e.clientX||0)-outsideStart.x);
        const dy=Math.abs((e.clientY||0)-outsideStart.y);
        if(dx>8||dy>8) return;
      }
      closeDrawer();
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    document.addEventListener('gwCartAdd', function(e) {
      if (window.location.pathname.includes('hexbox-case-file')) return;
      interceptAddToCart(e.detail.variantId, 1, e.detail.collection, e.detail.sellingPlan);
    });

    /* Header cart icon: opens the SAME drawer showing the full basket,
       instead of navigating to /cart, wherever the drawer exists on the
       page. No "Added to your bag" banner here — nothing was just
       added, the customer is just checking their bag. */
    const cartIcon=document.getElementById('cart-icon-bubble');
    if(cartIcon){
      cartIcon.addEventListener('click',function(e){
        e.preventDefault();
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          openDrawerWithCart(cart,{showAdded:false,justAddedVariantIds:[]});
        });
      });
    }
  });

  /* /cart page (Dawn's stock main-cart-items + assets/cart.js) has its own
     quantity controls, entirely separate from this drawer. Rather than
     rewriting that stock component, this hooks Dawn's own pubsub event
     (fired after every one of ITS successful /cart/change.js calls) and
     runs the exact same case-link cascade, then reloads the page so the
     fix is reflected — correctness over smoothness on this secondary
     path, since the drawer is the primary, polished flow. */
  if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      var cart = payload && payload.cartData;
      if (!cart || !cart.items) return;
      applyCaseLinkRules(cart).then(function (finalCart) {
        if (finalCart !== cart) window.location.reload();
      });
    });
  }

  window.gwOpenCartDrawer=function(p,cart){ openDrawerWithCart(cart,{showAdded:true,justAddedVariantIds:p&&p.variant_id?[p.variant_id]:[]}); };
  window.gwInterceptAddToCart=interceptAddToCart;
  window.gwInterceptAddToCartMulti=interceptAddToCartMulti;

  /* Promise-based variant of interceptAddToCart, added for the tarot
     deck's "In the bag" success/failure UI (A3) — interceptAddToCart
     itself is left untouched since other callers (franchise page,
     bundle builder, etc.) already depend on its exact fire-and-forget
     behaviour. /cart/add.js returns a 4xx body with a `status`/`message`
     on failure (e.g. sold out) rather than throwing, so success is
     judged by the response having a real line-item id, not just by the
     fetch resolving. */
  function addToCartWithResult(variantId, quantity, collection, sellingPlan, opts) {
    const body = { id: variantId, quantity: quantity || 1 };
    if (sellingPlan) body.selling_plan = sellingPlan;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(r => r.json().then(item => ({ ok: r.ok, item: item })))
      .then(result => {
        if (!result.ok || !result.item || !result.item.id) {
          const message = (result.item && result.item.description) || (result.item && result.item.message) || 'That item is unavailable right now.';
          return Promise.reject({ message: message });
        }
        return fetch('/cart.js').then(r => r.json()).then(cart => {
          if (opts && opts.noDrawer) {
            updateHeaderCount(cart);
            document.dispatchEvent(new CustomEvent('gw:cart:change', { detail: { cart: cart } }));
          } else {
            openDrawerWithCart(cart, { showAdded: true, justAddedVariantIds: [result.item.variant_id] });
          }
          return result.item;
        });
      })
      .catch(err => {
        if (err && err.message) return Promise.reject(err);
        return Promise.reject({ message: 'That item is unavailable right now.' });
      });
  }
  window.gwAddToCartWithResult=addToCartWithResult;
})();
